import { motion } from "framer-motion"

interface FeedbackRatingButtonsProps {
  isLoading: boolean
  isSuccess: boolean // TODO handle success and failure request
  onClick: (confidence: number) => void
}

export default function FeedbackRatingButtons({ isLoading, onClick }: FeedbackRatingButtonsProps) {
  const buttons = [
    { id: 1, color: "bg-red-500 hover:bg-red-600" },
    { id: 2, color: "bg-orange-500 hover:bg-orange-600" },
    { id: 3, color: "bg-yellow-500 hover:bg-yellow-600" },
    { id: 4, color: "bg-lime-500 hover:bg-lime-600" },
    { id: 5, color: "bg-green-500 hover:bg-green-600" },
  ]

  const handleOnClick = (confidence: number) => {
    onClick(confidence)
  }

  return (
    <div className="flex flex-col items-center gap-4 p-4">
      <h2 className="text-lg font-medium text-gray-700" style={{ opacity: isLoading ? "0" : "10" }}>
        ¿Qué tan acertada fue tu respuesta?
      </h2>
      <div className="flex gap-4">
        {buttons.map(({ id, color }, index) => (
          <motion.button
            key={id}
            onClick={() => !isLoading && handleOnClick(id)}
            className={`h-12 w-12 rounded-full text-lg font-bold text-white ${color}`}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={
              isLoading
                ? {
                    scale: [1, 1, 1],
                    y: [0, -12, 0],
                    transition: {
                      duration: 0.5,
                      repeat: Infinity,
                      repeatDelay: 0.1,
                      delay: index * 0.1,
                    },
                  }
                : {
                    opacity: 1,
                    scale: 1,
                    y: 0,
                    transition: {
                      type: "spring",
                      stiffness: 300,
                      damping: 20,
                      delay: index * 0.05,
                    },
                  }
            }
            whileTap={!isLoading ? { scale: 0.95 } : {}}
          >
            {id}
          </motion.button>
        ))}
      </div>
    </div>
  )
}
